export default {
    Isencao: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "isencao"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Isencao.js
// module id = lHCr
// module chunks = 13